import React from 'react'
import FaqsTop from './FaqsTop'

const FaqsArea = () => {

  return (
    <>
    <FaqsTop/>

    <section id="faqs_arae_main" className="section_padding_bottom">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="faqs_area">
                        <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        What is PCF?
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            PCF (Pakistani Cultural &amp; Sports Organisation) supports Pakistani families in
                                            Sweden through <strong>culture</strong>, <strong>education</strong>, and <strong>integration</strong>. Our main sport is
                                            <strong>badminton</strong>; we also run seasonal swimming, cricket, football, and social gatherings.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        How can my child join sport at PCF?
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            <strong>Badminton</strong> is our main year-round activity—email us for hall times and junior
                                            groups. We also open <strong>seasonal blocks</strong> for swimming, cricket, and football when
                                            venues and weather allow; announcements go out by newsletter.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Do you charge membership fees?
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse"
                                    aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Some activities may ask for a small fee to cover hall hire, equipment, or
                                            insurance. We aim to keep costs low and can discuss support for families who
                                            need it—please speak to us in confidence.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFour">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour" aria-expanded="false"
                                        aria-controls="collapseFour">
                                        Is PCF only for Pakistani citizens?
                                    </button>
                                </h2>
                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour"
                                    data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <p>
                                            Our programmes focus on Pakistani heritage and community life in Sweden. Families
                                            of mixed background and friends who respect our values are welcome at many public
                                            events; specific groups may have their own guidelines.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="faqs_area">
                        <div className="accordion" id="accordionExample2">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOneright">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOneright" aria-expanded="true">
                                        How can I volunteer?
                                    </button>
                                </h2>
                                <div id="collapseOneright" className="accordion-collapse collapse show"
                                    aria-labelledby="headingOneright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Email volunteer@pcfsweden.se or use the contact form. We need coaches, assistant
                                            coaches, homework tutors, event setup helpers, and people with skills in media or
                                            fundraising.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTworight">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTworight" aria-expanded="false"
                                        aria-controls="collapseTworight">
                                        Where do activities take place?
                                    </button>
                                </h2>
                                <div id="collapseTworight" className="accordion-collapse collapse"
                                    aria-labelledby="headingTworight" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Venues change by season and city. <strong>Badminton</strong> uses indoor halls; swimming uses
                                            pools; cricket and football use grass or artificial turf when scheduled. Exact
                                            addresses are shared after registration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThreeright">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThreeright" aria-expanded="false"
                                        aria-controls="collapseThreeright">
                                        How are children kept safe?
                                    </button>
                                </h2>
                                <div id="collapseThreeright" className="accordion-collapse collapse"
                                    aria-labelledby="headingThreeright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Volunteers who work regularly with children follow our code of conduct. We
                                            recommend background checks where Swedish law and insurance require them, and we
                                            train leads on first aid and safeguarding basics.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFourright">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourright" aria-expanded="false"
                                        aria-controls="collapseFourright">
                                        How do I stay updated?
                                    </button>
                                </h2>
                                <div id="collapseFourright" className="accordion-collapse collapse"
                                    aria-labelledby="headingFourright" data-bs-parent="#accordionExample2">
                                    <div className="accordion-body">
                                        <p>
                                            Subscribe via the form in the footer, follow our upcoming social channels, and
                                            check the News section for announcements about registrations and major events.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default FaqsArea
